/** Nur Tierwohlprotokoll: Tagesdaten ohne UTC-JSON. Der globale KieneDateAdapter bleibt unverändert. */

const TWP_DATE_KEYS = [
    'datum',
    'durchfuehrung_bis',
    'naechster_bestandsbesuch',
    'parasitologische_massnahmen_endoparasiten_zuletzt',
    'parasitologische_massnahmen_ektoparasiten_zuletzt',
] as const;

function toLocalNoon(year: number, monthIndex: number, day: number): Date {
    return new Date(year, monthIndex, day, 12, 0, 0);
}

function parseTwpDate(value: unknown): Date | null {
    if (value == null || value === '') {
        return null;
    }
    if (value instanceof Date) {
        if (Number.isNaN(value.getTime())) {
            return null;
        }
        return toLocalNoon(value.getFullYear(), value.getMonth(), value.getDate());
    }
    const raw = String(value).trim();
    const ymd = /^(\d{4})-(\d{2})-(\d{2})(?:[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?)?$/.exec(raw);
    if (ymd) {
        return toLocalNoon(+ymd[1], +ymd[2] - 1, +ymd[3]);
    }
    const de = /^(\d{1,2})\.(\d{1,2})\.(\d{2,4})$/.exec(raw);
    if (de) {
        let year = +de[3];
        if (year < 100) {
            year += year >= 70 ? 1900 : 2000;
        }
        return toLocalNoon(year, +de[2] - 1, +de[1]);
    }
    const parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) {
        return null;
    }
    return toLocalNoon(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
}

function formatTwpDate(value: unknown): string | null {
    const date = parseTwpDate(value);
    if (!date) {
        return null;
    }
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
}

export function applyParsedTierwohlDates<T>(twp: T): T {
    const row = twp as Record<string, unknown>;
    for (const key of TWP_DATE_KEYS) {
        if (!(key in row)) {
            continue;
        }
        row[key] = parseTwpDate(row[key]);
    }
    return twp;
}

export function withFormattedTierwohlDates<T>(twp: T): T {
    const payload = { ...(twp as Record<string, unknown>) };
    for (const key of TWP_DATE_KEYS) {
        if (!(key in payload)) {
            continue;
        }
        payload[key] = formatTwpDate(payload[key]);
    }
    return payload as unknown as T;
}
